import React from "react";
import Group from "../group/group";
var TopSection = function TopSection(_ref) {
  var data = _ref.data,
    language = _ref.language,
    dictionary = _ref.dictionary,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/React.createElement("ul", {
    className: "footer__top-section"
  }, data.map(function (group, index) {
    return /*#__PURE__*/React.createElement(Group, {
      key: "group-".concat(index),
      group: group,
      index: index,
      language: language,
      isMobile: isMobile,
      dictionary: dictionary
    });
  }));
};
export default TopSection;